import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Country} from '@spartacus/core';

@Component({
  selector: 'dcp-country-switch-content',
  templateUrl: './country-switch-content.component.html',
  styleUrls: ['./country-switch-content.component.scss']
})
export class CountrySwitchContentComponent {

  @Input() modal: NgbActiveModal;
  @Input() countries: Country[];
  /** Country selected by the user */
  @Input() requestedCountry: string;
}
